


























import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel2 } from "@/components";
import info from "./components/info.vue";
import integralSet from "./components/integralSet.vue";
import levelSet from "./components/levelSet.vue";
@Component({
    components: {
        padHeadPanel2,info,integralSet,levelSet
    },
})
export default class vip extends Vue {

    active='hyxx';

    userInfo = {};
   
    public $refs: {
    };
    created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    }
    activated() {
        this.active='hyxx';
    }

    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/vip.vue